<template>
  <div class="menu-mobile-secondary">
    <MenuMobileHeader @stepBack="$emit('stepBack')" @close="$emit('close')">
      {{ result.name }}
    </MenuMobileHeader>
    <div class="menu-mobile-secondary__items">
      <a v-if="result.title" :href="result.href" class="menu-mobile-secondary__title">{{
        result.title
      }}</a>
      <a
        v-for="(item, i) in getItems"
        :key="i"
        :href="item.href"
        class="menu-mobile-secondary__item"
      >
        {{ item.name }}
        <span v-if="item.new" class="menu-mobile-secondary__new">{{ item.new }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import MenuMobileHeader from '@components/Menu/MenuMobile/MenuMobileHeader.vue';

export default {
  name: 'MenuMobileSecondary',
  components: { MenuMobileHeader },
  props: ['result'],
  computed: {
    getItems() {
      return this.result?.items?.filter((el) => el.elementCnt !== 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-mobile-secondary {
  position: fixed;
  z-index: 3;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: #f5f5f5;
  &__items {
    display: grid;
    grid-auto-rows: 48px;
    grid-row-gap: 8px;
    overflow-y: auto;
    max-height: calc(100% - 48px);
    padding: 8px 16px 0;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    background-color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
  }
  &__title {
    display: flex;
    align-items: center;
    padding: 0 16px;
    font-size: 16px;
    font-weight: 500;
    line-height: 125%;
    text-transform: uppercase;
    color: var(--color-golden-browm);
    background-color: #fff;
  }
  &__new {
    font-size: rem(12);
    font-weight: 400;
    color: var(--color-green);
    margin-left: 8px;
  }
}
</style>
